import { Tier } from 'app/shared/account/tier.model';
import { AudienceFilterOperator } from './audience.model';

export interface SessionConditionGroup {
  id?: number;
  createdTime?: string | Date;
  updatedTime?: string | Date;
  name?: string;
  sessionConditions?: Array<SessionCondition>;
  accountId?: string;
  accountGroupId?: string;
  shareForWholeAccountsGroup?: boolean;
}

export interface WidgetSessionConditionsFlyoutResponse {
  sessionConditions?: Array<SessionCondition>;
  sessionConditionGroupId?: number;
  widgetId?: number;
}

export interface SessionCondition {
  id?: number;
  type?: SessionConditionType;
  operator?: AudienceFilterOperator;
  value?: string;
  show?: boolean;
  conditionConfig?: SessionConditionConfig;
  conditionTranslations?: SessionConditionTranslations;
  chooseItemKey?: string;
}

export interface SessionConditionTranslations {
  type?: string;
  operator?: string;
  value?: string;
  campaignEventOperator?: string;
  campaignEventValue?: string;
}

export enum SessionConditionCampaignEventOperator {
  Equals = 'Equals',
  MoreThan = 'MoreThan',
  LessThan = 'LessThan',
}

export interface SessionConditionCampaignEventConfig {
  times: number;
  campaignId: number;
}

export enum SessionConditionType {
  QueryParam = 'QueryParam',
  UTMCampaign = 'UTMCampaign',
  UTMSource = 'UTMSource',
  UTMMedium = 'UTMMedium',
  BrowserLanguage = 'BrowserLanguage',
  FacebookVisit = 'FacebookVisit',
  InstagramVisit = 'InstagramVisit',
  OtherSocialMediaVisit = 'OtherSocialMediaVisit',
  MarketingEmailVisit = 'MarketingEmailVisit',
  JsExpression = 'JsExpression',
  CookieExists = 'CookieExists',
  CookieEquals = 'CookieEquals',
  OnlyMobile = 'OnlyMobile',
  OnlyDesktop = 'OnlyDesktop',
  Domain = 'Domain',
  NewVisitor = 'NewVisitor',
  ReturningVisitor = 'ReturningVisitor',
  CampaignOpened = 'CampaignOpened',
  CampaignDismissal = 'CampaignDismissal',
  CampaignConversion = 'CampaignConversion',
  CampaignClickthrough = 'CampaignClickthrough',
  CampaignSurveyResponse = 'CampaignSurveyResponse',
  IdentifiedEmailMarketing = 'IdentifiedEmailMarketing',
  LoggedIn = 'LoggedIn',
  Tablet = 'Tablet',
  MobileOrTablet = 'MobileOrTablet',
  OperatingSystem = 'OperatingSystem',
  // Outdated
  Query = 'Query',
}

export enum SessionConditionOperator {
  Equals = 'Equals',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
  Contains = 'Contains',
  AnyOf = 'AnyOf',
  NotEquals = 'NotEquals',
  MoreThan = 'MoreThan',
  LessThan = 'LessThan',
}

export interface SessionConditionConfig {
  type: SessionConditionType;
  icon?: string;
  disabled?: boolean;
  svgIcon?: string;
  titleKey: string;
  operator?: string;
  defaultOperator?: AudienceFilterOperator;
  supportedOperators?: Array<AudienceFilterOperator>;
  placeholderKey?: string;
  descriptionKey: string;
  /** The condition dialog's lead-in, when descriptionKey doesn't lead into the comparison. */
  leadInKey?: string;
  defaultValue?: string;
  defaultShow: boolean;
  inputWidth?: number;
  inlineEditKey1?: string;
  inlineEditKey2?: string;
  formFieldType?: string;
  requiresPopup?: boolean;
  isNew?: true;
  disabledOnTiers?: Tier[];
  /** The audience builders express these as audience rules instead. */
  widgetOnly?: true;
}

export interface SessionConditionConfigGroup {
  type?: string;
  conditions?: Array<SessionConditionConfig>;
}

export enum SessionConditionLanguages {
  English = 'English',
  Swedish = 'Swedish',
  Norwegian = 'Norwegian',
  Finnish = 'Finnish',
  Danish = 'Danish',
  Arabic = 'Arabic',
  Bengali = 'Bengali',
  Chinese = 'Chinese',
  Dutch = 'Dutch',
  French = 'French',
  German = 'German',
  Hindustani = 'Hindustani',
  Italian = 'Italian',
  Malay = 'Malay',
  Polish = 'Polish',
  Portuguese = 'Portuguese',
  Russian = 'Russian',
  Spanish = 'Spanish',
}

/** The widget runtime compares these values, so they must match its detector exactly. */
export enum SessionConditionOperatingSystems {
  Windows = 'Windows',
  macOS = 'macOS',
  iOS = 'iOS',
  Android = 'Android',
}
